import React from 'react';
import { createRoot } from 'react-dom/client';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
// layouts
import MainLayout from './layouts/MainLayout';
import LoginLayout from './layouts/LoginLayout';
import ForgotPasswordLayout from './layouts/ForgotPasswordLayout';
import ConfirmForgotPasswordLayout from './layouts/ConfirmForgotPasswordLayout';
import ResetPasswordLayout from './layouts/ResetPasswordLayout';
// actions
import { setUserInSession } from './auth/AuthActions';
import AuthRefreshToken from './auth/AuthRefreshToken';
import RouterPaths from './constants/RouterPaths';
// redux
import { prepareStore } from './redux/Store';
import StateCleaner from './redux/StateCleaner';
// hooks
import { useCustomNavigate } from './common/hooks/useCustomNavigate';
// contexts
import { LayoutProvider } from './contexts/useLayoutContext';
// alerts
import AlertContainer from './common/components/alert/AlertContainer';
// styles
import 'assets/scss/paper-dashboard.scss';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'simplebar-react/dist/simplebar.min.css';
import './App.css';
import './assets/scss/app.scss';

export const store = prepareStore();
setUserInSession(store.dispatch);

function AppWithNavigation() {
  useCustomNavigate();
  const env = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT;

  return (
    <>
      {env !== 'PROD' && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <StateCleaner />
      <Routes>
        <Route path={RouterPaths.LOGIN} element={<LoginLayout />} />
        <Route path={RouterPaths.FORGOT_PASSWORD} element={<ForgotPasswordLayout />} />
        <Route
          path={RouterPaths.CONFIRM_FORGOT_PASSWORD}
          element={<ConfirmForgotPasswordLayout />}
        />
        <Route path={RouterPaths.RESET_PASSWORD} element={<ResetPasswordLayout />} />
        <Route path="/*" element={<MainLayout />} />
      </Routes>
      <AlertContainer />
    </>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AuthRefreshToken />
    <BrowserRouter basename="/">
      <LayoutProvider>
        <AppWithNavigation />
      </LayoutProvider>
    </BrowserRouter>
  </Provider>,
);
